import { preAuthRootReducer } from "../reducers/preAuthReducer";
import { setStore as setTrackingStore } from "../utils/tracking/trackingStoreEnricher";
import type Api from "../api/Api";
import ApiInstance from "../api/ApiInstance";
import PreAuthAPI from "../api/PreAuthAPI";
import { setStore as setToastStore } from "../components/app/Notifications/notifications";
import createStore, { setThunkAPI } from "./createStore";
import { setupViteHmr } from "./setupHmr";

export function initStore() {
    const preAuthApi = new PreAuthAPI();
    setThunkAPI(preAuthApi);
    // Before we auth we use the pre-auth api
    ApiInstance.api = preAuthApi as any as Api;
    const store = createStore(preAuthRootReducer, undefined);
    setupViteHmr(store);
    setTrackingStore(store);
    setToastStore(store);
    return store;
}

export function initPostAuthStore(store) {
    // update store to use post-auth reducer
    return import("./initPostAuthStore").then(({ default: _initPostAuthStore }) => _initPostAuthStore(store));
}
